import { useEffect, useCallback, useState } from 'react';

import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox, TablePagination } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest, setOrderData } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import { Select } from 'element-react';
import * as XLSX from 'xlsx';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

const CustomsUIItems = ({ order, loginUser, data1, data1Org, index, updateData1, saveCustomsUIData, setCustomsUiData }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const [data, setData] = useState(data1);
    const [prodData, setProdData] = useState(JSON.parse(JSON.stringify(data?.productData)));
    const [invoiceOptions, setInvoiceOptions] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [totalItems, setTotalItems] = useState(1);
    const [totalCost, setTotalCost] = useState(1);
    const [selectedInvoice, setSelectedInvoice] = useState(1);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [selectedInvoiceName, setSelectedInvoiceName] = useState("ALL");
    const [shipper, setShipper] = useState("");
    const [consignee, setConsignee] = useState("");
    const pageOptions = [10, 20, 30, 50];
    const [pageNum, setPageNum] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const resetFilter = (page, num) => {
        var total_items = 0;
        var total_cost = 0;
        var start = page * num
        if (data.productData)
            if (typeof data.productData === 'string')
                data.productData = JSON.parse(data.productData);
        var list = data?.productData?.filter(f => filterFun(f, selectedInvoiceName)).slice(start, start + num);
        for (var i = 0; i < list?.length; i++) {
            total_items += (list[i].quantity ? list[i].quantity : 0);
            total_cost += (list[i].total_value ? list[i].total_value : 0);
        }
        setTotalItems(total_items);
        setTotalCost(total_cost);
        setSelectedInvoices(list);
    }
    const updateData = (dt) => {
        updateData1(dt);
        setData(dt);
        updateDat(dt);
    }
    const onPageHandleChange = (_, newPage) => {
        setPageNum(newPage);
        resetFilter(newPage, perPage);
    };

    const onRowsPerPageHandleChange = event => {
        setPerPage(+event.target.value);
        setPageNum(0);
        resetFilter(0, event.target.value);
    };
    const getInvoiceRef = (invoice) => {
        if (invoice.document_ref)
            return invoice.document_ref
        return invoice.fields.find(f => f.field === "order_number")?.value
    }
    const updateDat = (dat) => {
        var invs = [];
        invs.push({ id: 1, name: "ALL" });
        if(dat?.aiData?.file_validation) {
            if (dat?.aiData?.file_validation?.invoices) {
                for (var i = 0; i < dat.aiData.file_validation.invoices.length; i++) {
                    var dt = {};
                    dt.id = i + 2;
                    dt.name = getInvoiceRef(dat.aiData.file_validation.invoices[i]);
                    invs.push(dt);
                }
            }
        }
        setInvoiceOptions(invs);
        setInvoices(dat?.productData);
        resetFilter(pageNum, perPage);
    }
    useEffect(() => {
        updateDat(data);
    }, [data]);

    /*const loadHSCode = () => {
        alert("Load HS Code!");
    }*/

    const loadHSCode = (id) => {
        sendRequest('/api/customsUI/loadHSCodes?orderId=' + data.orderId + "&setId=" + data.id + "&user=" + loginUser.id, REQUEST_ACTIONS.POST, '', {
            loginUser: loginUser,
            successCallback: response => {
                if (response)
                    setCustomsUiData(response);
            },
            failedCallback,
        });
    }

    const filterFun = (data, name) => {
        if (name === "ALL")
            return true;
        if (data.invoice_number) {
            if (data.invoice_number === name)
                return true;
        }
        return false;
    }

    const jsonToExcel = function (data, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        XLSX.writeFile(wb, name + ".xlsx");
    }
    const exportCSV = () => {
        var data_main = [];
        var header = [];
        var reap = invoices?.filter(f => filterFun(f, selectedInvoiceName));
        var fileKeys = Object.keys(data.fileData);
        for (var i = 0; i < reap.length; i++) {
            var file = null;
            for (var j = 0; j < fileKeys.length; j++) {
                var fl = data.fileData[fileKeys[j]];
                if (fl.invoice_number) {
                    if (fl.invoice_number === reap[i].invoice_number) {
                        file = fl;
                        break
                    }
                }
            }
            var dt = {
                "רץ סחורה": i + 1,
                "מק״ט": reap[i].product_id,
                "פרט מכס": reap[i].hscode ? reap[i].hscode : (reap[i].hs_code ? reap[i].hs_code : ""),
                "הסכם": "",
                "ערך סחורות": reap[i].total_value ? reap[i].total_value : "",
                "כמות": reap[i].quantity,
                "יחידת מידה": "EA",
                "מקור": file?.country_of_origin ? file.country_of_origin : "",
                "תיאור טובין": 1,
                "אישורים": ""
            };
            data_main.push(dt);
        }
        jsonToExcel(data_main, "items", header);
    }
    const saveCustomsUIData1 = (dat) => {

        setProdData(JSON.parse(JSON.stringify(dat?.productData)));
        if (dat.fileData)
            dat.fileData = JSON.stringify(dat.fileData);
        if (dat.aiData)
            dat.aiData = JSON.stringify(dat.aiData);
        if (dat.productData) {
            if (typeof dat.productData === 'string')
                dat.productData = JSON.parse(dat.productData);
            dat.productData = JSON.stringify(dat.productData);
        }
        sendRequest('/api/customsUI/setCustomsData', REQUEST_ACTIONS.POST, dat, {
            loginUser: loginUser,
            successCallback: response => {
                if (response) {
                    var data = JSON.parse(JSON.stringify(response));
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].fileData)
                            if (typeof data[i].fileData === 'string')
                                data[i].fileData = JSON.parse(data[i].fileData);
                        if (data[i].aiData)
                            if (typeof data[i].aiData === 'string')
                                data[i].aiData = JSON.parse(data[i].aiData);
                        if (data[i].productData)
                            if (typeof data[i].productData === 'string')
                                data[i].productData = JSON.parse(data[i].productData);
                    }
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].id == dat.id) {
                            updateData(data[i]);
                        }
                    }
                }
            },
            failedCallback,
        });
    }

    const getInvoiceName = () => {
        if (selectedInvoiceName === "ALL") {
            return invoiceOptions[1]?.name || selectedInvoiceName;
        }
        return selectedInvoiceName;
    }

    const [changed, setChanged] = useState(0);


    useEffect(() => {
    }, [changed]);



    const [showHideDefaults, setShowHideDefaults] = useState(false);
    const [defaultCountry, setDefaultCountry] = useState(null);
    const [defaultCurrency, setDefaultCurrency] = useState(null);
    const [defaultQuantity, setDefaultQuantity] = useState(null);

    const setDefaultItems = () => {
        var sInv = JSON.parse(JSON.stringify(invoices));
        for (var i = 0; i < sInv.length; i++) {
            if (defaultCountry) {
                sInv[i].country_of_origin = defaultCountry;
            }
            if (defaultCurrency) {
                sInv[i].currency = defaultCurrency;
            }
            if (defaultQuantity) {
                sInv[i].quantity = defaultQuantity;
            }
        }
        setInvoices(sInv)
    }

    const [sortByMakat, setSortByMakat] = useState(null);
    const [searchByMakat, setSearchByMakat] = useState(null);
    const [sortByProdName, setSortByProdName] = useState(null);
    const [searchByProdName, setSearchByProdName] = useState(null);
    const [sortByHSCode, setSortByHSCode] = useState(null);
    const [searchByHSCode, setSearchByHSCode] = useState(null);
    const [sortByCountry, setSortByCountry] = useState(null);
    const [searchByCountry, setSearchByCountry] = useState(null);
    const [sortByCur, setSortByCur] = useState(null);
    const [searchByCur, setSearchByCur] = useState(null);
    const [sortByUnitCost, setSortByUnitCost] = useState(null);
    const [searchByUnitCost, setSearchByUnitCost] = useState(null);
    const [sortByQty, setSortByQty] = useState(null);
    const [searchByQty, setSearchByQty] = useState(null);
    const [sortByTotal, setSortByTotal] = useState(null);
    const [searchByTotal, setSearchByTotal] = useState(null);
    const [sortByHeDesc, setSortByHeDesc] = useState(null);
    const [searchByHeDesc, setSearchByHeDesc] = useState(null);
    const [sortByEnDesc, setSortByEnDesc] = useState(null);
    const [searchByEnDesc, setSearchByEnDesc] = useState(null);
    const [sortByRemarks, setSortByRemarks] = useState(null);
    const [searchByRemarks, setSearchByRemarks] = useState(null);
    const [sortBySIVUG, setSortBySIVUG] = useState(null);
    const [searchBySIVUG, setSearchBySIVUG] = useState(null);
    const [sortByComment, setSortByComment] = useState(null);
    const [searchByComment, setSearchByComment] = useState(null);

    const resetAllSort = () => {
        setSortByMakat(null);
        setSortByProdName(null);
        setSortByHSCode(null);
        setSortByCountry(null);
        setSortByCur(null);
        setSortByUnitCost(null);
        setSortByQty(null);
        setSortByTotal(null);
        setSortByHeDesc(null);
        setSortByEnDesc(null);
        setSortByRemarks(null);
        setSortBySIVUG(null);
    }
    const check = (a, b) => {
        if (a && b) {
            return a.localeCompare(b)
        }
        if (a && !b) {
            return -1;
        }
        if (b && !a) {
            return 1;
        }
        return 0;
    }
    useEffect(() => {
        if (invoices) {
            var sInv = JSON.parse(JSON.stringify(invoices));
            if (sortByMakat) {
                if (sortByMakat == 2) {
                    sInv.sort((a, b) => check(a.product_id, b.product_id));
                }
                if (sortByMakat == 1) {
                    sInv.sort((b, a) => check(a.product_id, b.product_id));
                }
            }
            if (sortByProdName) {
                if (sortByProdName == 2) {
                    sInv.sort((a, b) => check(a.description, b.description));
                }
                if (sortByProdName == 1) {
                    sInv.sort((b, a) => check(a.description, b.description));
                }
            }
            if (sortByHSCode) {
                if (sortByHSCode == 2) {
                    sInv.sort((a, b) => check(a.hs_code, b.hs_code));
                }
                if (sortByHSCode == 1) {
                    sInv.sort((b, a) => check(a.hs_code, b.hs_code));
                }
            }
            if (sortByCountry) {
                if (sortByCountry == 2) {
                    sInv.sort((a, b) => check(a.country_of_origin, b.country_of_origin));
                }
                if (sortByCountry == 1) {
                    sInv.sort((b, a) => check(a.country_of_origin, b.country_of_origin));
                }
            }
            if (sortByCur) {
                if (sortByCur == 2) {
                    sInv.sort((a, b) => check(a.currency, b.currency));
                }
                if (sortByCur == 1) {
                    sInv.sort((b, a) => check(a.currency, b.currency));
                }
            }
            if (sortByUnitCost) {
                if (sortByUnitCost == 2) {
                    sInv.sort((a, b) => Number(a.unit_price) - Number(b.unit_price));
                }
                if (sortByUnitCost == 1) {
                    sInv.sort((b, a) => Number(a.unit_price) - Number(b.unit_price));
                }
            }
            if (sortByQty) {
                if (sortByQty == 2) {
                    sInv.sort((a, b) => Number(a.quantity) - Number(b.quantity));
                }
                if (sortByQty == 1) {
                    sInv.sort((b, a) => Number(a.quantity) - Number(b.quantity));
                }
            }
            if (sortByTotal) {
                if (sortByTotal == 2) {
                    sInv.sort((a, b) => Number(a.total_value) - Number(b.total_value));
                }
                if (sortByTotal == 1) {
                    sInv.sort((b, a) => Number(a.total_value) - Number(b.total_value));
                }
            }
            if (sortByComment) {
                if (sortByComment == 2) {
                    sInv.sort((a, b) => check(a.comment, b.comment));
                }
                if (sortByComment == 1) {
                    sInv.sort((b, a) => check(a.comment, b.comment));
                }
            }
            if (sortByHeDesc) {
                if (sortByHeDesc == 2) {
                    sInv.sort((a, b) => check(a.desche, b.desche));
                }
                if (sortByHeDesc == 1) {
                    sInv.sort((b, a) => check(a.desche, b.desche));
                }
            }
            if (sortByEnDesc) {
                if (sortByEnDesc == 2) {
                    sInv.sort((a, b) => check(a.desc, b.desc));
                }
                if (sortByEnDesc == 1) {
                    sInv.sort((b, a) => check(a.desc, b.desc));
                }
            }
            if (sortByRemarks) {
                if (sortByRemarks == 2) {
                    sInv.sort((a, b) => check(a.remarks, b.remarks));
                }
                if (sortByRemarks == 1) {
                    sInv.sort((b, a) => check(a.remarks, b.remarks));
                }
            }
            if (sortBySIVUG) {
                if (sortBySIVUG == 2) {
                    sInv.sort((a, b) => check(a.hscode, b.hscode));
                }
                if (sortBySIVUG == 1) {
                    sInv.sort((b, a) => check(a.hscode, b.hscode));
                }
            }
            if (searchByMakat)
                sInv = sInv.filter(a => a.product_id?.includes(searchByMakat))
            if (searchByProdName)
                sInv = sInv.filter(a => a.description.includes(searchByProdName))
            if (searchByHSCode)
                sInv = sInv.filter(a => a.hs_code?.includes(searchByHSCode))
            if (searchByCountry)
                sInv = sInv.filter(a => a.country_of_origin?.includes(searchByCountry))
            if (searchByCur)
                sInv = sInv.filter(a => a.currency?.includes(searchByCur))
            if (searchByUnitCost)
                sInv = sInv.filter(a => Number(a.unit_price) == Number(searchByUnitCost))
            if (searchByQty)
                sInv = sInv.filter(a => Number(a.quantity) == Number(searchByQty))
            if (searchByTotal)
                sInv = sInv.filter(a => Number(a.total_value) == Number(searchByTotal))
            if (searchByHeDesc)
                sInv = sInv.filter(a => a.desche?.includes(searchByHeDesc))
            if (searchByEnDesc)
                sInv = sInv.filter(a => a.desc?.includes(searchByEnDesc))
            if (searchByRemarks)
                sInv = sInv.filter(a => a.remarks?.includes(searchByRemarks))
            if (searchBySIVUG)
                sInv = sInv.filter(a => a.hscode?.includes(searchBySIVUG))
            if (searchByComment)
                sInv = sInv.filter(a => a.comment?.includes(searchByComment))
            var list = sInv?.filter(f => filterFun(f, selectedInvoiceName)).slice(pageNum, perPage);
            setSelectedInvoices(list);
        }
    }, [invoices,
        sortByMakat, sortByProdName, sortByHSCode, sortByCountry, sortByCur, sortByUnitCost, sortByQty, sortByTotal, sortByHeDesc, sortByEnDesc, sortByRemarks, sortBySIVUG,
        sortByComment, searchByMakat,
        searchByProdName, searchByHSCode, searchByCountry, searchByCur, searchByUnitCost, searchByQty, searchByTotal, searchByHeDesc,
        searchByEnDesc, searchByRemarks, searchBySIVUG, searchByComment
    ]);

    const getDBData = (pd) => {
        var list = [];
        list.push("HS CODE: " + (pd.hscode ? pd.hscode : ""));
        list.push("Prod Desc: " + (pd.desc ? pd.desc : ""));
        list.push("Prod Desc HE: " + (pd.desche ? pd.desche : ""));
        list.push("Vendor: " + (pd.shipper ? pd.shipper : ""));
        list.push("Consignee: " + (pd.consigneeName ? pd.consigneeName : ""));
        list.push("remarks: " + (pd.remarks ? pd.remarks : ""));
        list.push("Makat: " + (pd.dbMakat ? pd.dbMakat : ""));

        return list.join('\n');
    }
    const getDBcolor = (pd) => {
        //return "#F0FFF0";
        if (!getChangedColor(pd)) {
            return "#FFFFBF";
        }
        if (pd.hscode)
            return "#F0FFF0";
        return "#FFF";
    }
    function shallowEqual(obj1, obj2) {
        if (!obj1 || !obj2)
            return true;
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        var equal = true;
        for (var i = 0; i < keys1.length; i++) {
            if (obj1[keys1[i]] === obj2[keys1[i]]) {
            }
            else {
                console.log(obj2)
                return false;
            }
        }
        return true;
        //return keys1.every(key => obj1[key] === obj2[key]);
    }
    const getChangedColor = (pd) => {
        var dat = prodData?.filter(f => f.lineId === pd.lineId);
        if (dat?.length) {
            if (shallowEqual(dat[0], pd))
                return true;
        }
        return false;
    }
    return (
        <>
            <Grid item container style={{ marginBottom: "10px", width: "92vw" }} alignItems="center" flexWrap="nowrap">
                <SelectField
                    label='Invoice' 
                    lg={3}
                    value={selectedInvoice}
                    onChange={event => {
                        setSelectedInvoice(event.target.value);
                        resetAllSort();
                        var sel = invoiceOptions.find(f => f.id == event.target.value);
                        setSelectedInvoiceName(sel?.name);
                        if (sel?.name) {
                            var list = invoices?.filter(f => filterFun(f, sel.name)).slice(pageNum, perPage)
                            setSelectedInvoices(list);
                        }
                    }}
                    options={invoiceOptions}
                />
                <TextField
                    lg={3}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Shipper'
                    value={data?.aiData?.documents?.invoices?.find(f => f.order_number === getInvoiceName())?.shipper_name}
                />
                <TextField
                    lg={3}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Consignee'
                    value={data?.aiData?.documents?.invoices?.find(f => f.order_number === getInvoiceName())?.consignee_name}
                />
                <TextField
                    lg={1}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Currency'
                    value={data?.aiData?.file_validation?.invoices?.find(f => f.order_number === getInvoiceName())?.currency}
                />
                <TextField
                    lg={1}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Total Items'
                    value={totalItems}
                />
                <TextField
                    lg={1}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Total Cost'
                    value={totalCost}
                />
                <UnfoldMoreIcon onClick={() => setShowHideDefaults(!showHideDefaults)} />
            </Grid>
            {showHideDefaults   && <Grid item container style={{ marginBottom: "10px", width: "92vw" }} alignItems="center">
                <TextField
                    lg={3}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Country'
                    value={defaultCountry}
                    onChange={event => setDefaultCountry(event.target.value)}

                />
                <TextField
                    lg={3}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Currency'
                    value={defaultCurrency}
                    onChange={event => setDefaultCurrency(event.target.value)}

                />
                <TextField
                    lg={3}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Quantity'
                    value={defaultQuantity}
                    onChange={event => setDefaultQuantity(event.target.value)}

                />
                {<Button
                    variant='contained'
                    style={{ margin: "15px" }}
                    onClick={setDefaultItems}>
                    Set {defaultCountry ? "Country" + (defaultCurrency || defaultQuantity ? ", " : "") : ""} {defaultCurrency ? "Currency" + (defaultQuantity ? ", " : "") : ""} {defaultQuantity ? "Quantity " : ""}
                </Button>}
            </Grid>}
            <div style={{ height: "500px", overflowY: "auto", display: "block", width: "100%" }}>
                <Grid item container style={{ border: "1px grey solid", borderRadius: "5px", maxHeight: "500px", display: "block", overflowY: "auto" }}>
                    <table style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ maxWidth: "100px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='MAKAT'
                                            value={searchByMakat}
                                            onChange={event => setSearchByMakat(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByMakat(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByMakat == 2)
                                                setSortByMakat(null);
                                            else {
                                                if (sortByMakat == 1)
                                                    setSortByMakat(2);
                                                else
                                                    setSortByMakat(1);
                                            }
                                            }}>↕</span>
                                    </Grid>
                                </th>
                                <th>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Product Name'
                                            value={searchByProdName}
                                            onChange={event => setSearchByProdName(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByProdName(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByProdName == 2)
                                                setSortByProdName(null);
                                            else {
                                                if (sortByProdName == 1)
                                                    setSortByProdName(2);
                                                else
                                                    setSortByProdName(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "100px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='HS Code'
                                            value={searchByHSCode}
                                            onChange={event => setSearchByHSCode(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByHSCode(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByHSCode == 2)
                                                setSortByHSCode(null);
                                            else {
                                                if (sortByHSCode == 1)
                                                    setSortByHSCode(2);
                                                else
                                                    setSortByHSCode(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "100px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Country'
                                            value={searchByCountry}
                                            onChange={event => setSearchByCountry(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByCountry(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByCountry == 2)
                                                setSortByCountry(null);
                                            else {
                                                if (sortByCountry == 1)
                                                    setSortByCountry(2);
                                                else
                                                    setSortByCountry(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "50px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Cur'
                                            value={searchByCur}
                                            onChange={event => setSearchByCur(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByCur(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByCur == 2)
                                                setSortByCur(null);
                                            else {
                                                if (sortByCur == 1)
                                                    setSortByCur(2);
                                                else
                                                    setSortByCur(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "75px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Number"
                                            label='Unit Cost'
                                            value={searchByUnitCost}
                                            onChange={event => setSearchByUnitCost(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByUnitCost(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByUnitCost == 2)
                                                setSortByUnitCost(null);
                                            else {
                                                if (sortByUnitCost == 1)
                                                    setSortByUnitCost(2);
                                                else
                                                    setSortByUnitCost(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "70px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Number"
                                            label='Qty'
                                            value={searchByQty}
                                            onChange={event => setSearchByQty(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByQty(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByQty == 2)
                                                setSortByQty(null);
                                            else {
                                                if (sortByQty == 1)
                                                    setSortByQty(2);
                                                else
                                                    setSortByQty(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ maxWidth: "75px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Number"
                                            label='Total'
                                            value={searchByTotal}
                                            onChange={event => setSearchByTotal(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByTotal(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByTotal == 2)
                                                setSortByTotal(null);
                                            else {
                                                if (sortByTotal == 1)
                                                    setSortByTotal(2);
                                                else
                                                    setSortByTotal(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ borderRight: "1px solid grey", maxWidth: "125px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Comment'
                                            value={searchByComment}
                                            onChange={event => setSearchByComment(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByComment(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByComment == 2)
                                                setSortByComment(null);
                                            else {
                                                if (sortByComment == 1)
                                                    setSortByComment(2);
                                                else
                                                    setSortByComment(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ backgroundColor: "#efefff" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Hebrew Desc'
                                            value={searchByHeDesc}
                                            onChange={event => setSearchByHeDesc(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByHeDesc(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByHeDesc == 2)
                                                setSortByHeDesc(null);
                                            else {
                                                if (sortByHeDesc == 1)
                                                    setSortByHeDesc(2);
                                                else
                                                    setSortByHeDesc(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ backgroundColor: "#efefff" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Product Desc'
                                            value={searchByEnDesc}
                                            onChange={event => setSearchByEnDesc(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByEnDesc(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByEnDesc == 2)
                                                setSortByEnDesc(null);
                                            else {
                                                if (sortByEnDesc == 1)
                                                    setSortByEnDesc(2);
                                                else
                                                    setSortByEnDesc(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ backgroundColor: "#efefff" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='Remarks'
                                            value={searchByRemarks}
                                            onChange={event => setSearchByRemarks(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchByRemarks(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortByRemarks == 2)
                                                setSortByRemarks(null);
                                            else {
                                                if (sortByRemarks == 1)
                                                    setSortByRemarks(2);
                                                else
                                                    setSortByRemarks(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ backgroundColor: "#efefff", maxWidth: "100px" }}>
                                    <Grid item container flexWrap="nowrap" alignItems="center">
                                        <TextField
                                            lg={12}
                                            type="Text"
                                            label='SIVUG'
                                            value={searchBySIVUG}
                                            onChange={event => setSearchBySIVUG(event.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    setSearchBySIVUG(e.target.value.trim());
                                                }
                                            }}
                                        />
                                        <span class="sort" onClick={() => {
                                            resetAllSort();
                                            if (sortBySIVUG == 2)
                                                setSortBySIVUG(null);
                                            else {
                                                if (sortBySIVUG == 1)
                                                    setSortBySIVUG(2);
                                                else
                                                    setSortBySIVUG(1);
                                            }
                                        }}>↕</span>
                                    </Grid>
                                </th>
                                <th style={{ backgroundColor: "#efefff" }}>
                                    <span onClick={() => {
                                        var dt = {
                                            product_id: "",
                                            qty: "",
                                            desc: "",
                                            price: "",
                                            hscode: "",
                                        }
                                        if (!data?.productData) {
                                            data.productData = [];
                                        }
                                        data.productData.unshift(dt);
                                        updateData(data);
                                    }}>+</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedInvoices?.map((pd, ind) => (
                                <tr key={ind}>
                                    <td style={{ maxWidth: "75px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.product_id}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].product_id = event.target.value;
                                                updateData(dt);
                                            }}
                                        />

                                    </td>
                                    <td style={{ backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.description}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].description = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "100px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.hs_code}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].hs_code = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "100px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.country_of_origin}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].country_of_origin = event.target.value;
                                                updateData(dt);
                                                setChanged(changed + 1);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "50px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.currency}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].currency = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "75px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.unit_price}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].unit_price = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "70px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.quantity}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].quantity = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ maxWidth: "75px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.total_value}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].total_value = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ borderRight: "1px solid grey", maxWidth: "75px", backgroundColor: getDBcolor(pd) }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.comment}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].comment = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ backgroundColor: "#efefff66" }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.desche}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].desche = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ backgroundColor: "#efefff66" }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.desc}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].desc = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ backgroundColor: "#efefff66" }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.remarks}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].remarks = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ backgroundColor: "#efefff66", maxWidth: "115px" }}>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={pd.hscode}
                                            onChange={event => {
                                                var dt = JSON.parse(JSON.stringify(data));
                                                dt.productData[ind].hscode = event.target.value;
                                                updateData(dt);
                                            }}
                                        />
                                    </td>
                                    <td style={{ backgroundColor: "#efefff66" }}>
                                        <Grid item container flexWrap="nowrap">
                                            <Grid title={getDBData(pd)} style={{padding: "1px 7px", marginRight: "3px", borderRadius: "20px", border: "1px solid grey"}}>i</Grid>
                                            <span onClick={() => {
                                                /*var dt = [];
                                                for (var i = 0; i < data.productData.length; i++) {
                                                    if (data.productData[i].product_id != pd.product_id &&
                                                        data.productData[i].line_number != pd.line_number) {
                                                        dt.push(data.productData[i]);
                                                    }
                                                }
                                                data.productData = dt;*/
                                                var ind1 = ind + (pageNum * perPage)
                                                data.productData.splice(ind1, 1);
                                                updateData(data);
                                            }}>-</span>
                                        </Grid>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Grid>
            </div>
            <Grid item container flexDirection="row-reverse" flexWrap="nowrap">
                <Grid item container flexDirection="row-reverse" lg={6}>
                    {<Button
                        variant='contained'
                        style={{ margin: "15px", maxWidth: "150px" }}
                        onClick={() => { saveCustomsUIData1(data)} }>
                        Save
                    </Button>}
                    {<Button
                        variant='contained'
                        style={{ margin: "15px", maxWidth: "150px" }}
                        onClick={loadHSCode}>
                        Load HS Codes
                    </Button>}
                    {<Button
                        variant='contained'
                        style={{ margin: "15px", maxWidth: "150px" }}
                        onClick={exportCSV}>
                        Export Items
                    </Button>}
                </Grid>
                <Grid item container flexDirection="rows" lg={6}>
                    <TablePagination
                        rowsPerPageOptions={pageOptions}
                        component='div'
                        count={invoices?.length | 0}
                        rowsPerPage={perPage}
                        page={pageNum}
                        onPageChange={onPageHandleChange}
                        onRowsPerPageChange={onRowsPerPageHandleChange}
                    />
                </Grid>
            </Grid>
        </>
    );
}


export default CustomsUIItems;